const TableHeader = () => {
  return (
    <div className="g-grid g-header">
      <div className="row">
        <div className="col capitalize center separator-line">
          Vrsta / Projekat
        </div>
        <div className="col capitalize center separator-line">
          Zaposleni
        </div>
        <div className="col capitalize center separator-line">
          Datum
        </div>
        <div className="col uppercase center separator-line">
          IZNOS
        </div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
};

export default TableHeader;
